document.addEventListener('DOMContentLoaded', () => {
  const banners = document.querySelectorAll('.banner, .banner__content, .hero');
  const products = document.querySelectorAll('product-card');

  const bannerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        bannerObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0 });

  const productObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('is-visible'), i * 200);
        productObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.03 });

  banners.forEach(el => bannerObserver.observe(el));
  products.forEach(el => productObserver.observe(el));
});
